import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import Statsig from 'statsig-js';

// Sidebar Service
@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private menusSubject = new BehaviorSubject<Array<any>>([]);
  constructor() {}

  public getMenus(): any[] {
    return this.menusSubject.value;
  }

  public setMenus(menus: any) {
    this.menusSubject.next(menus);
  }

  public updateMenuWithFlag(
    menus: any[],
    mainTitle: string,
    flag: string,
    submenu: any
  ): any[] {
    if (Statsig.checkGate(flag)) {
      menus.forEach((menu) => {
        if (menu.activeUrl === mainTitle) {
          const submenuIndex = menu.submenus.findIndex(
            (sub: { title: any }) => sub.title === submenu.title
          );
          if (submenuIndex === -1) {
            menu.submenus.unshift({ ...submenu, activeUrl: menu.activeUrl });
          }
        }
      });

      menus.forEach((menu) => {
        if (menu.activeUrl === mainTitle) {
          menu.submenus.sort((a: { title: string }, b: { title: any }) =>
            a.title.localeCompare(b.title)
          );
        }
      });
    }
    this.menusSubject.next(menus);
    return menus;
  }

  public updateMenusBasedOnStatsigState(statsigUser: any): void {
    if (statsigUser) {
      let menus = this.getMenus();
      if (Statsig.checkGate('show_dashboard')) {
        if (!menus.find((value: any) => value.url === '/dashboard')) {
          menus.unshift({
            title: 'DASHBOARD',
            name: 'dashboard',
            url: '/dashboard',
            activeUrl: 'dashboard',
            icon: 'fa-gauge',
            icon2: '',
            submenus: [],
          });
        }
      }

      if (Statsig.checkGate('show_campaign')) {
        if (!menus.find((value: any) => value.url === '/campaign')) {
          menus.push({
            title: 'CAMPAIGN',
            name: 'campaign',
            url: '/campaign',
            activeUrl: '/campaign',
            icon: 'fa-bullhorn',
          });
        }
      }

      if (Statsig.checkGate('show_campaign_automation')) {
        if (!menus.find((value: any) => value.url === '/automation')) {
          menus.push( {
            title: 'AUTOMATION',
            name: 'automation',
            url: '/automation',
            activeUrl: '/automation',
            icon: 'fa-users-gear',
          });
        }
      }

      this.menusSubject.next(menus);
    }
  }
}
